import styled from 'styled-components';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 15;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100%;
	padding-top: 212px;
	background-color: rgba(17, 19, 20, 0.98);
`;

const StyledCategories = styled.div`
	display: flex;
	gap: 20px;
	margin-top: 37px;
`;

const StyledCategory = styled.div<{ $active?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 18px;
	padding-top: 24px;
	width: 120px;
	height: 120px;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)'};
	border-radius: 10px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 40px;
		height: 40px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${TextLabel} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		transition: color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}

		${TextLabel} {
			color: #000000;
		}
	}
`;

const StyledButton = styled.button`
	width: 120px;
	height: 40px;
	margin-top: 40px;
	background-color: #2d70da;
	border-radius: 10px;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #ffffff;
	border: none;
	cursor: pointer;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}
`;

const StyledCrossButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	margin-top: 20px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

export {
	StyledButton,
	StyledCategories,
	StyledCategory,
	StyledContainer,
	StyledCrossButton,
};
